module.exports = __webpack_public_path__ + "img/vivo-2.eaec8f64.png";